import { createContext } from "react";

const RefsContext = createContext({
  refs: {},
});

export default RefsContext;
